import React, { useState, useEffect } from "react";
import useHttp from "../../hooks/use-http";
import { toast } from "react-toastify";
import { utils, read } from "xlsx";
import ReactFileReader from "react-file-reader";
import Pagination from "../../components/Pagination";
import moment from "moment";

const FarmerUploadFMN = () => {
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [formData, setFormData] = useState();
  const [areaData, setAreaData] = useState([]);  
  const [departmentData, setDepartmentData] = useState([]);  
  const [designationData, setDesignationData] = useState([]);  
  const [seasonData, setSeasonData] = useState([]);  
  
  
  const [regionData, setRegionData] = useState([]);
  var d = new Date();
  var dateString =
    d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear() +" "+d.getHours() + ":"+d.getMinutes()+ ":"+d.getSeconds();


  
  const {

      sendRequest: getArea,
    } = useHttp();
  



  const {

    sendRequest: getRegion,
  } = useHttp();

  useEffect(() => {
    getRegion(
      {
        url: `/api/procurementRegionList/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        //console.log("region", data);

        setRegionData(data.data);
      
      }
    );
  }, [getRegion]);

  useEffect(() => {
      getArea(
        {
          url: `/api/areaDetails/?orgId=${localStorage.getItem("orgId")}`,
        },
        (data) => {
          console.log("areaDetails", data.data);
  
          setAreaData(data.data);
        
        }
      );
    }, [getArea]);
  

    const {

      sendRequest: getDesignation,
    } = useHttp();

    
    useEffect(() => {
      getDesignation(
        {
          url: `/api/designation/?orgId=${localStorage.getItem("orgId")}`,
        },
        (data) => {
          // console.log(data);
          setDesignationData(data);
        }
      );
    }, [getDesignation]);


    const {

      sendRequest: getDepartment,
    } = useHttp();

    useEffect(() => {
      getDepartment(
        {
          url: `/api/department/?orgId=${localStorage.getItem("orgId")}`,
        },
        (data) => {
          //console.log(data);
          setDepartmentData(data);
        }
      );
    }, [getDepartment]);
  

  const { sendRequest: getEmp } = useHttp();
  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setEmployeeData(data.output);
      }
    );
  }, [getEmp]);





  const {

    sendRequest: getSeasonList,
  } = useHttp();

  useEffect(() => {
    getSeasonList(
      {
        url: `/api/seasons/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
         setSeasonData(data);
      }
    );
  }, [getSeasonList]);


  function generateUniqueID() {
    const currentDateTime = new Date();
    const uniqueID =
      currentDateTime.getTime() + Math.floor(Math.random() * 1000);

    return uniqueID.toString();
  }

  const handleFileRead = (e) => {
    const content = e.target.result;
    const workbook = read(content, { type: "binary" });
    const firstSheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[firstSheetName];
    const parsedData1 = utils.sheet_to_json(worksheet, { header: 1 });
    
    const parsedData=parsedData1.filter(item=>item[0]!="");
    console.log(parsedData);
    setData(parsedData);
    setAllData(parsedData);
   
    const headers = parsedData[0];
    var tempfarmerId= generateUniqueID ()
    var counterId=1;
    const jsonData = parsedData.slice(1).map((row,index) => {
     console.log("row",row)
    

      const employeeCode= row[headers.indexOf("Employee Code")];
      const areaName = row[headers.indexOf("Area Name")];
      const regionName= row[headers.indexOf("Region Name")];
      var farmerEducation= row[headers.indexOf("Farmer Education")];
      var accountName  = row[headers.indexOf("Account Name")];
      var bankName  = row[headers.indexOf("Bank Name")];
      var seasonName  = row[headers.indexOf("Season")];
      console.log("employeeCode",employeeCode)

      if (accountName.toString().toLowerCase()=="nill")
        {
          accountName="";
        }

        if (bankName.toString().toLowerCase()=="nill")
          {
            bankName="";
          }

          
      if (farmerEducation.toString()=="" || farmerEducation.toString().toLowerCase()=="none")
      {
        farmerEducation="No Formal Education"
      }else  if (farmerEducation.toString().toLowerCase()=="primary" || farmerEducation.toString().toLowerCase()=="secondary")
      {
        farmerEducation=farmerEducation + " Education"
      }

        const fieldExecutive = employeeData.find(
        (employee) => employee.employeeCode === employeeCode
      );
      

      const regionobj = regionData.find(
        (regionitem) => regionitem.regionName === regionName
      );

      
      const areaobj = areaData.find(
        (areaitem) => areaitem.areaName === areaName
      );
      var farmerId=tempfarmerId+counterId.toString()
      counterId=counterId+1;
      
      const seasonobj = seasonData.find(
        (seasonitem) => seasonitem.seasonName === seasonName
      );
 

  
      var bdate=row[headers.indexOf("DOB")]
      var rdate=row[headers.indexOf("Registration Date")]
      console.log("bdate",bdate) 
      let birth_date = new Date(Math.round((bdate - 25569) * 864e5));
      birth_date = moment(birth_date).format('DD/MM/YYYY')
      console.log("birth_date",birth_date) 
      // birth_date=bdate
      console.log("birth_date",birth_date) 
      console.log("rdate",rdate) 
      let registration_date = new Date(Math.round((rdate - 25569) * 864e5));
      registration_date = moment(registration_date).format('DD/MM/YYYY')
      console.log("registration_date",registration_date) 
      //registration_date =rdate
      console.log("registration_date",registration_date) 

      const employee = {
        farmerId:farmerId,
        farmerNo:row[headers.indexOf("Farmer Id")]??"",
        registrationDate: registration_date,          
        farmerName: row[headers.indexOf("Farmer Name")],
        plotSizeInHa: row[headers.indexOf("Plot Size(Ha)")],
        gender: row[headers.indexOf("Gender")],
        mobile: row[headers.indexOf("Mobile")],
        bvn: row[headers.indexOf("BVN")],
        season: row[headers.indexOf("Season")],
        seasonId:seasonobj.seasonId,
        farmerStatus: row[headers.indexOf("Farmer Status")],
        farmerEducation:farmerEducation,	
        religion:row[headers.indexOf("Religion")],	
        dob:  birth_date ,
        ageRange:row[headers.indexOf("Age Range")],	
        areaId :areaobj ? areaobj.areaId : null,
        areaName :areaName,
        regionId :regionobj ? regionobj.regionId : null,
        maritalStatus:row[headers.indexOf("Marital Status")],	
        category:row[headers.indexOf("Category")], 	
        address:row[headers.indexOf("Farmer Address")],	
        country:row[headers.indexOf("Country")],	
        state:row[headers.indexOf("State")],	
        lga:row[headers.indexOf("LGA")],	
        villageName:row[headers.indexOf("Village")],	
        accountNumber:row[headers.indexOf("Account Number")],	
        accountHolderName:accountName,	
        bankName:bankName,	         
        enrollmentPlace:row[headers.indexOf("Enrolled Place")],
        orgId: localStorage.getItem("orgId"),
        empId:fieldExecutive.empId,
        createdBy:fieldExecutive.userId,
        fieldExecutiveId:fieldExecutive.userId,
        createdDate: dateString,
 
       };

      return employee;
    });
    console.log("Farmer jsonData",jsonData);

    
    setFormData(jsonData);
  };




  const handleFileUpload = (files) => {
    const file = files[0];
    const fileReader = new FileReader();
    fileReader.onloadend = handleFileRead;
    fileReader.readAsBinaryString(file);
  };
  const [itemsPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: postAddFarmeer } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();
    console.log("formData",formData)
    postAddFarmeer(
      {
        url: "/api/uploadFarmer/",
        method: "POST",
        body: formData,
      },
      (data) => {
        toast.success(`Farmeer added successfully`);
        setData([]);
      }
    );
        setFormData("");
  };
  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">&nbsp;
                <form onSubmit={submitHandler}>
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-10">   <label className="card-title mx-2 my-3 ">
                          FMN Farmer Details
                        </label></div>

                        <div className="col-2">
                          <ReactFileReader
                            handleFiles={handleFileUpload}
                            fileTypes={".xlsx"}
                          >
                            <button
                              type="button"
                              className="btn  btn-primary mx-2 my-2"
                            >
                              Upload Excel
                            </button>
                          </ReactFileReader>{" "}
                        </div>
                      </div>

                      <div className="row">
                        <table className="table table-bordered table-responsive text-center table-sm">
                          <thead>
                            <tr className="tableheaderrowview">
                              {data[0] &&
                                data[0].map((header, index) => (
                                  <th key={index}>{header}</th>
                                ))}
                            </tr>
                          </thead>
                          <tbody>
                            {data &&
                              data.slice(1).map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                  {row.map((cell, cellIndex) => (
                                    <td key={cellIndex}>{cell}</td>
                                  ))}
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    {/* /.card-body */}
                    <div className="card-footer clearfix">
                      <Pagination
                        totalItems={data.length}
                        itemsPerPage={itemsPerPage}
                        onPageChange={paginate}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                      />
                    </div>
                  </div>

                  <div className="text-center">
                    <button className="btn  btn-primary mx-2 my-2" type="submit">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default FarmerUploadFMN;
